<template>
  <div class="template welcome">
    <el-form :inline="true">
      <el-form-item :label="$t('im.common.visitorsType')">
        <el-select :no-data-text="$t('common.nodata')" v-model="userType" :placeholder="$t('im.common.placeholderVisitorsType')">
          <el-option
            v-for="item in userTypeData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.businessType')">
        <el-select :no-data-text="$t('common.nodata')" v-model="businessGroupCode" :placeholder="$t('im.common.placeholderBusinessType')">
          <el-option
            v-for="item in businessGroupData"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.locale')" v-if="langList&&langList.length>0">
        <el-select v-model="langId" :placeholder="$t('im.common.placeholderLanguage')">
          <el-option
            v-for="item in langList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchRule">{{$t('im.bt.search')}}</el-button>
        <el-button @click="resetRule">{{$t('im.bt.reset')}}</el-button>
        <el-button type="primary" @click="addWelcome">{{$t('im.bt.add')}}</el-button>
        <el-button @click="deleteAllPop">{{$t('im.bt.delete')}}</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="24">
      <el-col :span="3">
        <div class="boxShadow" :style="{'minHeight':util.accDiv(height,1.25)+'px'}">
          <div class="title"><span>{{$t('im.welcome.title')}}</span></div>
          <el-tree v-if="treeData" :data="treeData" :props="treeIDs" default-expand-all @node-click="selectNode"></el-tree>
        </div>
      </el-col>
      <el-col :span="21">
        <div class="boxShadow" :style="{'minHeight':util.accDiv(height,1.25)+'px'}">
          <el-table :data="welcomeList" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'background': '#eee'}" @selection-change="selectionWelcome">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :prop="item.id" :label="item.name" v-for="item in welcomeNav" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column :label="$t('im.bt.operator')">
              <template slot-scope="scope">
                <el-button size="mini" @click="editWelcomePop(scope.row)">{{$t('im.bt.update')}}</el-button>
                <el-button size="mini" type="danger" @click="deletePop(scope.row)">{{$t('im.bt.delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="flexEnd" v-if="totalNum>0">
            <el-pagination
              background
              @size-change="pageSizeChange"
              @current-change="currentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="welcomeTitle" :visible.sync="isToWelcomePop">
      <el-form class="div_form" :style="{'maxHeight':util.accDiv(height,1.6)+'px'}">
        <el-form-item :label="$t('im.common.bizCodeName')" class="flexEnd">
          <el-select v-model="businessGroupCodeTc" :placeholder="$t('im.common.placeholderBizCodeName')" @change="changeTcBusinessGroup">
            <el-option
              v-for="item in businessGroupData"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.common.locale')" class="flexEnd" v-if="langList&&langList.length>0">
          <el-select v-model="langIdTc" :placeholder="$t('im.common.placeholderLanguage')" @change="changeTcLang">
            <el-option
              v-for="item in langList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.common.visitorsType')" class="flexEnd">
          <el-select v-model="userTypeTc" :placeholder="$t('im.common.placeholderVisitorsType')" @change="changeTcVisitorsType">
            <el-option
              v-for="item in userTypeData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="editLabel" class="flexEnd" v-if="resourceType==1">
          <div class="flexEnd">
            <quill ref="quillEdit" :uploadUrl="uploadUrl" :quillId="quillId" :height="100"></quill>
            <!--<el-input type="textarea" :rows="3" v-model="editContentTxt" maxlength="200" show-word-limit></el-input>-->
          </div>
        </el-form-item>
        <addContent v-if="resourceType==0" :list="addWelcomeList.PC" :num="total.PC" :name="'PC'" :userInfo="userInfo" :businessGroupCode="businessGroupCodeTc" :userType="userTypeTc" :langId="langIdTc" @change="changeWelcomeMessage"></addContent>
        <addContent v-if="resourceType==0" :list="addWelcomeList.M" :num="total.M" :name="'M'" :userInfo="userInfo" :businessGroupCode="businessGroupCodeTc" :userType="userTypeTc" :langId="langIdTc" @change="changeWelcomeMessage"></addContent>
        <addContent v-if="resourceType==0" :list="addWelcomeList.APP" :num="total.APP" :name="'APP'" :userInfo="userInfo" :businessGroupCode="businessGroupCodeTc" :userType="userTypeTc" :langId="langIdTc" @change="changeWelcomeMessage"></addContent>
      </el-form>
      <div class="flexCenter" v-if="resourceType==1">
        <el-button type="primary" size="mini" @click="submitSave">{{$t('im.bt.definite')}}</el-button>
        <el-button size="mini" @click="isToWelcomePop=false">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  require('@/styles/IM/template.css')
  import apiDeployManagement from "@/api/im/deployManagement"
  import addContent from "@/views/IM/model/addContent"
  import { localRead} from '@/utils/tools'
  import quill from '@/views/IM/model/quill.vue'
  import Util from '@/utils/IM/tradeDataUtil'
  export default {
    name: 'welcome',
    components: { addContent,quill },
    data() {
      return {
        util: Util,
        height: '',
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        treeData: '',//树结构
        treeIDs: {
          children: 'children',
          label: 'name'
        },//树结构的字段名
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        langId: '',  //默认显示语言的ID
        langIdTc: 'zh_CN',  //默认弹窗显示语言的ID
        userType: '',//默认访客类型
        userTypeTc: 0,//默认弹窗访客类型ID
        userTypeData:[
          {name:window.$t('im.common.traveler'),id:0},
          {name:window.$t('im.common.demo'),id:1},
          {name:window.$t('im.common.inactivated'),id:2},
          {name:window.$t('im.common.activated'),id:3},
        ],//用户类型
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        bizCodes:"",//业务编码Code组
        businessGroupCode: '',  //业务编码Code
        businessGroupCodeTc: '',  //弹窗业务编码Code
        isToWelcomePop: false,  //是否显示新增欢迎语弹窗
        addWelcomeList: {
          PC: [],
          M: [],
          APP: []
        }, //不同客户端数据添加
        total:{
          PC:"",
          M:"",
          APP:"",
        }, //不同客户端数据条数
        welcomeNav: [
          { name: window.$t('im.common.userTypeName'), id: 'userTypeName' },
          { name: window.$t('im.common.bizCode'), id: 'bizCodeName' },
          { name: window.$t('im.common.locale'), id: 'localeName' },
          { name: window.$t('im.common.visitorsWay'), id: 'clientName' },
          { name: window.$t('im.common.sort'), id: 'sort' },
          { name: window.$t('im.common.content'), id: 'message' }
        ],  //表格头部
        welcomeList: [],  //欢迎语列表
        welcomeTotalList: [],  //欢迎语列表
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize:10, //当前页条数数
        multipleSelection: [],  //选择条数集合
        resourceType: 0,//0：新增，1：编辑
        resourceID: '',//当前数据ID
        welcomeTitle: window.$t('im.welcome.addWelcome'),  //标题
        editContentTxt: '',//编辑时内容
        editLabel: '',//编辑时客户端名称
        clientTypeData: [
          { name: window.$t('im.common.mobile'), id: 0 },
          { name: window.$t('im.common.pc'), id: 1 },
          { name: window.$t('im.common.app'), id: 2 }
        ],//访客方式
        quillId: 'quillID_edit',
        uploadUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',
      }
    },
    methods:{
      docHeight() {
        this.height = window.innerHeight || document.documentElement.clientHeight
      },
      /*选择资源*/
      selectionWelcome(val) {
        let data = []
        if (val.length > 0) {
          for (const i in val) {
            data.push(val[i].id)
          }
          this.multipleSelection = data
        } else {
          this.multipleSelection = []
        }
      },
      /*初始化属性结构*/
      initTreeData() {
        this.treeData = JSON.parse(JSON.stringify(this.businessGroupData))
        let data = []
        for (const i in this.treeData) {
          this.treeData[i].children = this.langList
          data.push(this.treeData[i].code)
        }
        this.bizCodes = data
      },
      /*选择弹窗语言*/
      changeTcLang(val) {
        this.brushWelcomeMessage(this.welcomeTotalList)
      },
      /*选择弹窗访客类型*/
      changeTcVisitorsType(val) {
        this.brushWelcomeMessage(this.welcomeTotalList)
      },
      /*选择弹窗业务编码*/
      changeTcBusinessGroup(val) {
        this.brushWelcomeMessage(this.welcomeTotalList)
      },
      /*初始化业务组tab*/
      initTcBusinessGroup() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCodeTc = this.businessGroupData[0].code
        }
      },
      /*新增*/
      addWelcome() {
        this.resourceType = 0
        this.isToWelcomePop = true
        this.welcomeTitle = window.$t('im.welcome.addWelcome')
        this.brushWelcomeMessage(this.welcomeTotalList)
      },
      /*修改当前*/
      editWelcomePop(data) {
        this.isToWelcomePop = true
        this.resourceType = 1
        this.welcomeTitle = window.$t('im.welcome.updateWelcome')
        this.resourceID = data.id
        this.businessGroupCodeTc = data.bizCode
        this.langIdTc = data.locale
        this.userTypeTc = data.userType
        this.$nextTick(() => {
          this.$refs.quillEdit.init(data.message)
        })
        // this.editContentTxt=data.message
        if (data.clientType == 0) {
          this.editLabel = 'M_' + data.sort
        } else if (data.clientType == 1) {
          this.editLabel = 'PC_' + data.sort
        } else if (data.clientType == 2) {
          this.editLabel = 'APP_' + data.sort
        }
      },
      submitSave() {
        if (Util.isNotEmpty(this.$refs.quillEdit.getHtml().replace(/\s/g, ''))){
          let data = {
            operator: this.userInfo.id,
            operatorName: this.userInfo.displayName,
            companyId: this.userInfo.companyId,
            bizCode: this.businessGroupCodeTc,
            locale: this.langIdTc,
            userType: this.userTypeTc,
            message: this.$refs.quillEdit.getHtml(),
            id: this.resourceID
          }
          apiDeployManagement.updateConWelcomeMessage(data).then(res => {
            if (res.code == 0) {
              this.isToWelcomePop = false
              this.initWelcomeMessageList()
            }
          })
        }
      },
      /*删除弹窗*/
      deletePop(row) {
        this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
          confirmButtonText: window.$t('im.bt.definite'),
          cancelButtonText: window.$t('im.bt.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteWelcome(row)
        }).catch(() => {
          this.$message.info(window.$t('im.common.cancelDel'))
        })
      },
      /*删除当前*/
      deleteWelcome(row) {
        let data = { id: row.id }
        apiDeployManagement.deleteConWelcomeMessage(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            let data = {
              companyId: this.userInfo.companyId,
              pageNum: this.currentPage,
              bizCode:this.businessGroupCode,
              locale:this.langId,
              userType: this.userType,
            }
            this.getWelcomeMessageList(data)
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*删除所有弹窗*/
      deleteAllPop() {
        if (this.multipleSelection.length > 0){
          this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
            confirmButtonText: window.$t('im.bt.definite'),
            cancelButtonText: window.$t('im.bt.cancel'),
            type: 'warning',
            center: true
          }).then(() => {
            this.deleteAllWelcome()
          }).catch(() => {
            this.$message.info(window.$t('im.common.cancelDel'))
          })
        }
      },
      /*删除所有*/
      deleteAllWelcome() {
        let data = { ids: this.multipleSelection.join(',') }
        apiDeployManagement.deleteBatchConWelcomeMessage(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            let data = {
              companyId: this.userInfo.companyId,
              pageNum: this.currentPage,
              bizCode:this.businessGroupCode,
              locale:this.langId,
              userType: this.userType,
            }
            this.getWelcomeMessageList(data)
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*切换分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          companyId: this.userInfo.companyId,
          pageSize: val,
          pageNum: this.currentPage,
          bizCode:this.businessGroupCode,
          locale:this.langId,
          userType: this.userType,
        }
        this.getWelcomeMessageList(data)
      },
      /*切换当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: val,
          pageSize: this.pageSize,
          bizCode:this.businessGroupCode,
          locale:this.langId,
          userType: this.userType,
        }
        this.getWelcomeMessageList(data)
      },
      /*刷选总数据*/
      brushWelcomeMessage(data) {
        let data_M = '', data_PC = '', data_APP = ''
        for (const i in data) {
          if (data[i].locale == this.langIdTc && data[i].userType == this.userTypeTc && data[i].bizCode == this.businessGroupCodeTc) {
            if (data[i].clientType == 0) {
              data_M = data[i]
            } else if (data[i].clientType == 1) {
              data_PC = data[i]
            } else if (data[i].clientType == 2) {
              data_APP = data[i]
            }
          }
        }
        this.total.PC = Util.isNotEmpty(data_PC) ? data_PC.sort + 1 : 1
        this.total.M = Util.isNotEmpty(data_M) ? data_M.sort + 1 : 1
        this.total.APP = Util.isNotEmpty(data_APP) ? data_APP.sort + 1 : 1
        this.addWelcomeList.PC = [{
          contentTxt: '',
          num: this.total.PC,
          len: Util.isNotEmpty(data_PC) ? data_PC.rowCount : 0
        }]
        this.addWelcomeList.M = [{
          contentTxt: '',
          num: this.total.M,
          len: Util.isNotEmpty(data_M) ? data_M.rowCount : 0
        }]
        this.addWelcomeList.APP = [{
          contentTxt: '',
          num: this.total.APP,
          len: Util.isNotEmpty(data_APP) ? data_APP.rowCount : 0
        }]
      },
      /*获取最大排序列*/
      getMaxSortRow(data) {
        apiDeployManagement.queryMaxSortRow(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.welcomeTotalList = res.result
              this.brushWelcomeMessage(res.result)
            } else {
              this.total.M = 1
              this.total.PC = 1
              this.total.APP = 1
            }
          }
        })
      },
      /*初始化最大排序列*/
      initMaxSortRow(){
        let data = {
          companyId: this.userInfo.companyId,
        }
        this.getMaxSortRow(data)
      },
      /*刷选业务列表*/
      brushBusinessGroup(obj) {
        for (const j in this.businessGroupData) {
          if (this.businessGroupData[j].code == obj.bizCode) {
            obj.bizCodeName = this.businessGroupData[j].name
          }
        }
        return obj
      },
      /*刷选语言*/
      brushLocale(obj){
        for (const j in this.langList) {
          if (this.langList[j].id == obj.locale) {
            obj.localeName = this.langList[j].name
          }
        }
        return obj
      },
      /*刷选访客方式*/
      brushClientType(obj) {
        for (const j in this.clientTypeData) {
          if (this.clientTypeData[j].id == obj.clientType) {
            obj.clientName = this.clientTypeData[j].name
          }
        }
        return obj
      },
      /*刷选用户类型*/
      brushUserType(obj) {
        for (const j in this.userTypeData) {
          if (this.userTypeData[j].id == obj.userType) {
            obj.userTypeName = this.userTypeData[j].name
          }
        }
        return obj
      },
      /*获取数据分页列表*/
      getWelcomeMessageList(data){
        apiDeployManagement.queryConWelcomeMessageListPage(data).then(res => {
          if (res.code == 0) {
            this.initMaxSortRow();
            if (res.result.list) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                this.brushBusinessGroup(newData[i])
                this.brushLocale(newData[i])
                this.brushClientType(newData[i])
                this.brushUserType(newData[i])
              }
              this.welcomeList = newData
              this.totalNum = res.result.total
            } else {
              this.welcomeList = []
              this.totalNum = 0
            }
          }
        })
      },
      /*初始化数据分页列表*/
      initWelcomeMessageList() {
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: this.currentPage,
          bizCodes: this.bizCodes
        }
        this.getWelcomeMessageList(data)
      },
      /*新增不同客户端条数*/
      changeWelcomeMessage(){
        this.initWelcomeMessageList()
      },
      /*选择节点刷选数据*/
      selectNode(obj,node) {
        this.businessGroupCodeTc = obj.children ? obj.code : node.parent.data.code
        this.langIdTc = obj.children ? 'zh_CN' : obj.id
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: this.currentPage,
          bizCode: obj.children ? obj.code : node.parent.data.code,
          locale: obj.children ? '' : obj.id
        }
        this.getWelcomeMessageList(data)
      },
      /*查询数据*/
      searchRule(){
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: 1,
          bizCode:this.businessGroupCode,
          locale:this.langId,
          userType: this.userType,
        }
        this.getWelcomeMessageList(data)
      },
      /*重置条件*/
      resetRule() {
        this.userType = ''
        this.businessGroupCode = ''
        this.langId = ''
        this.currentPage = 0
        this.initWelcomeMessageList()
      }
    },
    mounted() {
      this.docHeight();
      this.initTcBusinessGroup();
      this.initTreeData();
      this.initWelcomeMessageList()
    }
  }
</script>
<style>
  .welcome .div_form{overflow-y: scroll;overflow-x: hidden}
  .welcome .div_form .el-form-item__content{width: 80%}
  .welcome .div_form .el-select{width: 100%}
  .welcome .div_form .div_btn .el-button{margin: 5px 10px}
  .welcome .title {
    font-size: 14px;
    height: 48px;
    line-height: 48px;
    padding: 0 10px;
    margin-bottom: 10px;
    background: #eee;
  }
  .welcome .flexEnd .el-textarea .el-input__count{line-height: normal}
</style>
